<script lang="ts">
  import { theme } from '../utils/theme.svelte';
</script>

<button
  onclick={() => theme.toggle()}
  aria-label="Toggle theme"
  title="Toggle theme"
>
  <span class="icon">
    {#if theme.current === 'light'}
      ☾
    {:else}
      ☀
    {/if}
  </span>
</button>

<style>
  button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border: none;
    background-color: transparent;
    border-radius: 50%;
    transition: background-color 0.2s;
  }

  button:hover {
    background-color: var(--color-hover);
  }

  .icon {
    font-size: 1.5rem;
    line-height: 1;
  }
</style>
